import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { User, Mail, Phone, MapPin } from 'lucide-react';
import './FormStyles.css';

const CustomerForm = ({ onSubmit, initialData }) => {
  const [data, setData] = useState({
    fullname: initialData?.fullname || '',
    address: initialData?.address || '',
    phone: initialData?.phone || '',
    email: initialData?.email || ''
  });

  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};
    if (!data.fullname.trim()) newErrors.fullname = 'Full name is required';
    if (!data.address.trim()) newErrors.address = 'Address is required';
    if (!data.phone.trim()) newErrors.phone = 'Phone number is required';
    if (!data.email.trim()) newErrors.email = 'Email is required';
    else if (!/\S+@\S+\.\S+/.test(data.email)) newErrors.email = 'Email is invalid';
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData(prev => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      toast.error('Please fill all required fields');
      return;
    }

    // JUST PASS DATA TO PARENT - NO API CALL
    console.log('CustomerForm: Sending data to parent');
    onSubmit({ ...data });
  };

  return (
    <div className="form-card">
      <h2 className="form-title">
        <User size={24} /> Customer Information
      </h2>

      <form className="dynamic-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Full Name *</label>
          <input
            type="text"
            name="fullname"
            value={data.fullname}
            onChange={handleChange}
            placeholder="Enter full name"
            className={errors.fullname ? 'error' : ''}
          />
          {errors.fullname && <span className="error-text">{errors.fullname}</span>}
        </div>

        <div className="form-group">
          <label>Address *</label>
          <input
            type="text"
            name="address"
            value={data.address}
            onChange={handleChange}
            placeholder="Enter address"
            className={errors.address ? 'error' : ''}
          />
          {errors.address && <span className="error-text">{errors.address}</span>}
        </div>

        <div className="form-group">
          <label>Phone Number *</label>
          <input
            type="tel"
            name="phone"
            value={data.phone}
            onChange={handleChange}
            placeholder="Enter phone number"
            className={errors.phone ? 'error' : ''}
          />
          {errors.phone && <span className="error-text">{errors.phone}</span>}
        </div>

        <div className="form-group">
          <label>Email Address *</label>
          <input
            type="email"
            name="email"
            value={data.email}
            onChange={handleChange}
            placeholder="Enter email address"
            className={errors.email ? 'error' : ''}
          />
          {errors.email && <span className="error-text">{errors.email}</span>}
        </div>

        <button type="submit" className="submit-btn">Next →</button>
      </form>
    </div>
  );
};

export default CustomerForm;